import React from "react";
import Barcode from "react-barcode";
import styled from "styled-components";
import PropTypes from 'prop-types';

const PageBreakWrapper = styled.div`
  && {
    page-break-after: always;
  }
`;

const PrintTemplate = ({ detail }) => {
  return (
    <div>
      <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '12px', marginBottom: '5px' }}>CO.CO KIDS RE-STORE</div>
        <Barcode value={detail.UserId+"."+detail.codigoProducto}
           height= "55" /*format="EAN13"*/ displayValue={false} />
        <br />
        <div style={{ fontSize: '12px' }}> {detail.descripcion.substr(0, 20) +" - "+ detail.talle.substr(0, 21)+" - "+detail.marca.substr(0, 21)}</div>
      </div>
      <PageBreakWrapper>&nbsp;</PageBreakWrapper>
    </div>
  );
};
export default class ComponentToPrintSVG extends React.Component {
  render() {
    let printingPages = [];
    const { details } = this.props;
    for (const detail of details) {
      console.log(detail);
      const tempTemplate = <PrintTemplate detail={detail} />;
      printingPages.push(tempTemplate);
    }

    return (
      <div>
        {/* map and create single component for each page */}
        {printingPages}
      </div>
    );
  }
}
ComponentToPrintSVG.propTypes = {
    detail: PropTypes.array,
    details: PropTypes.array,
    data: PropTypes.array,
    handleClose: PropTypes.func
  };
  PrintTemplate.propTypes = {
    detail: PropTypes.shape({
        codigoProducto: PropTypes.string,
        descripcion: PropTypes.string,
        UserId: PropTypes.string,
        talle: PropTypes.string,
        marca: PropTypes.string,
    }).isRequired
  };